<template>
    <div class="contact">
        <!-- 微信 -->
        <div class="contact-item" @mouseenter="mouseEnter(0)" @mouseleave="mouseLeave()" @click="handleEnter(0)">
            <img src="@assets/common/icon_wechat.png" srcset="@assets/common/icon_wechat@2x.png 2x" class="contact-item-icon" />
            <div class="contact-item-img" v-if="mouseIndex === 0">
                <img :src="contactData.wechat_qrcode_image_url" />
            </div>
        </div>
        <!-- youtube -->
        <div class="contact-item" @mouseenter="mouseEnter(1)" @mouseleave="mouseLeave()" @click="handleEnter(1)">
            <img src="@assets/common/icon_youtube.png" srcset="@assets/common/icon_youtube@2x.png 2x" class="contact-item-icon" />
            <!-- <div class="contact-item-img" v-if="mouseIndex === 1">
                <div class="contact-item-img-text">{{ contactData.youtube }}</div>
            </div> -->
        </div>
        <!-- facebook -->
        <div class="contact-item" @mouseenter="mouseEnter(2)" @mouseleave="mouseLeave()" @click="handleEnter(2)">
            <img src="@assets/common/icon_facebook.png" srcset="@assets/common/icon_facebook@2x.png 2x" class="contact-item-icon" />
            <!-- <div class="contact-item-img" v-if="mouseIndex === 2">
                <div class="contact-item-img-text">{{ contactData.facebook }}</div>
            </div> -->
        </div>
        <!-- 电话 -->
        <div class="contact-item" @mouseenter="mouseEnter(3)" @mouseleave="mouseLeave()" @click="handleEnter(3)">
            <img src="@assets/common/icon_phone.png" srcset="@assets/common/icon_phone@2x.png 2x" class="contact-item-icon" />
            <div class="contact-item-img" v-if="mouseIndex === 3">
                <div class="contact-item-img-text">{{ contactData.phone }}</div>
            </div>
        </div>
        <!-- 置顶 -->
        <div class="contact-item contact-item-top" @click="handleTop">
            <img src="@assets/common/icon_top.png" srcset="@assets/common/icon_top@2x.png 2x" class="contact-item-icon"/>
        </div>
    </div>
</template>

<script setup>
    import { onMounted, ref } from 'vue';

    onMounted(() => {

    })

     const props = defineProps({
       contactData: { type: Object }
     })

    const handleTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // 鼠标移入定时器
    const timer = ref(null)

    // 鼠标移入下标
    const mouseIndex = ref(null)

    // 鼠标移入事件
    const mouseEnter = (index) => {
        mouseIndex.value = index
        clearTimeout(timer.value)
    }

    // 鼠标移出事件
    const mouseLeave = (min = 300) => {
        timer.value = setTimeout(() => {
             mouseIndex.value = null
        }, min)
    }

    const handleEnter = (index) => {
        mouseEnter(index)
        mouseLeave(5000)

        if(index === 1) window.open(props.contactData.youtube, '_blank')
        if(index === 2) window.open(props.contactData.facebook, '_blank')
        if(index === 3) window.open(`tel:${props.contactData.phone}`, '_self')
    }

</script>

<style lang="scss" scoped>
    .contact {
        position: fixed;
        right: 120px;
        bottom: 8vh;

        &-item {
            width: 40px;
            height: 40px;
            border-radius: 44px;
            background: linear-gradient(90deg, rgba(19, 94, 205, 1) 0%, rgba(12, 72, 161, 1) 100%),#0C3B81;
            box-shadow: 0px 1px 12px 0px rgba(13, 42, 85, 0.2);
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            margin-bottom: 20px;
            position: relative;

            &-img {
                position: absolute;
                width: fit-content;
                // height: 180px;
                border-radius: 6px;
                background-color: #FFFFFF;
                box-shadow: 0px 1px 12px 0px rgba(13, 42, 85, 0.2);
                right: 50px;
                box-sizing: border-box;
                padding: 10px;

                img {
                    width: 160px;
                    height: 160px;
                }

                &-text{
                    min-width: 160px;
                }
            }
        }

        &-item-top {
            background: #FFFFFF;
        }

    }

    /* 响应式设计 */
@media (max-width: 768px) {
    .contact {
        position: fixed;
        right: 30px;
        bottom: 10vh;

        &-item {
            width: 24px;
            height: 24px;
            border-radius: 14px;
            margin-bottom: 10px;

            &-icon {
                width: 14px;
                height: 14px;
            }

            &-img {
                width: 100px;
                // height: 100px;
                right: 30px;
                padding: 5px;

                img {
                    width: 90px;
                    height: 90px;
                }

                &-text{
                    min-width: 120px;
                    font-size: 12px;
                }
            }
        }
    }

}
</style>